"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoyaltyDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _BuyForPointsButton = require("./BuyForPointsButton");
var _DialogContent = require("./DialogContent");
var _DialogHeader = require("./DialogHeader");
var _jsxRuntime = require("react/jsx-runtime");
const LoyaltyDialog = () => {
  const {
    data,
    handleBuyForMoney,
    handleBuyForPoints,
    handleClose
  } = (0, _hooks.useLoyaltyDialog)();
  if (!data) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.LoyaltyDialogProvider, {
    value: data,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Dialog, {
      open: true,
      onClose: handleClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogHeader.DialogHeader, {
          points: data.loyaltyPoints
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.DialogContent, {
          actions: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Grid, {
            container: true,
            direction: "column",
            spacing: 3,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_BuyForPointsButton.BuyForPointsButton, {
                onClick: handleBuyForPoints
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
                fullWidth: true,
                variant: "outlined",
                color: "default",
                onClick: handleBuyForMoney,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
                  children: data.consultantPrice ?? 0
                })
              })
            })]
          })
        })]
      })
    })
  });
};
exports.LoyaltyDialog = LoyaltyDialog;
